module.exports = __webpack_public_path__ + "img/Weapon_250.7b1954b7.png";